<ion-header class="extendido" *ngIf="!loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Encarregado' | translate}}</ion-title>

    <ion-col class="end-filter">
      <div (click)="leitor()">
        <i class="fas fa-qrcode qr" aria-hidden="true"></i>
      </div>
    </ion-col>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="loaded"></app-loading-spinner>

<ion-content *ngIf="!loaded">
  <div class="gradient-extendido">
    <ion-searchbar
      show-cancel-button="never"
      animated="false"
      class="custom"
      (ionCancel)="onCancel()"
      placeholder="{{'Buscar Encarregado' | translate}}"
      [(ngModel)]="filtro.q"
      (ionInput)="onInput()"
    >
    </ion-searchbar>
  </div>

  <ion-grid>
    <ion-row *ngFor="let e of encarregadoList;">
      <ion-col class="remove-border">
        <ion-item class="avatar-square">
          <ion-avatar slot="start">
            <img [src]="e.pessoa.foto | image:' '" />
          </ion-avatar>

          <ion-label>
            <h3>{{e.pessoa.nome}}</h3>
            <p>{{e.pessoaFuncoesEspec.funcao}}</p>
          </ion-label>

          <ion-note slot="end">
            <ion-toggle
              [enableOnOffLabels]="true"
              [ngModel]="e.presenca == '1'"
              (ngModelChange)="changePresenca(e)"
              [disabled]="loadingPresenca[e.id]"
            ></ion-toggle>
          </ion-note>
        </ion-item>
      </ion-col>
    </ion-row>

    <sem-registro *ngIf="!encarregadoList.length"></sem-registro>

    <ion-infinite-scroll (ionInfinite)="loadEncarregados($event)" *ngIf="pagination.currentPage < pagination.pageCount">
      <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-grid>
</ion-content>
